<template>
	<div class="planer">
		<div class="planerTop">
			<div class="planerTop_left">
				<field
						margin="0 20px 0 0"
						width="300px"
						type="text"
						label="Start date"
						placeholder="Enter date"
						:dateValue="date"
						@updateDate="onDate"
						is-no-title
						is-date
				></field>
				<div v-once class="legend">
					<div class="legendItem internal ">Internal client</div>
					<div class="legendItem external">External client</div>
				</div>
			</div>
			<div class="planerTop_right">

<!--				<button @click="onNewWorkOrders(true)" class="btnPlaner newOrders">-->
<!--					NEW WORK ORDERS-->
<!--					<span v-if="newOrderCount" class="newOrders_count">{{ newOrderCount }}</span>-->
<!--				</button>-->

				<div class="badgeWrap">
					<v-badge
							v-if="newOrderCount"
							:content="newOrderCount"
							color="red"
							overlap
							offset-x="12"
							offset-y="12"
							bordered
					>
						<v-btn color="success" @click="onNewWorkOrders(true)">
							<span class="btnText">New work orders</span>
						</v-btn>
					</v-badge>
					<v-btn
							v-else
							@click="onNewWorkOrders(true)"
							color="success"
					>
						<span class="btnText">New work orders</span>
					</v-btn>
				</div>

<!--				<button-->
<!--						:disabled="!permissions[9]"-->
<!--						@click="onPlanerDayOff(true)" class="btnPlaner dayOff"-->
<!--				>Add day off-->
<!--				</button>-->

				<v-btn
						:disabled="!permissions[9]"
						@click="onPlanerDayOff(true)"
						color="blue"
						depressed
				>
					Add day off
				</v-btn>

				<v-btn
						:disabled="!permissions[9]"
						@click="onPlanerWorkOrder({orderId: null, isLightOrder: true}, true)"
						color="blue-grey"
						depressed
				>
					Add external work order
				</v-btn>

<!--				<button-->
<!--						:disabled="!permissions[9]"-->
<!--						@click="onPlanerWorkOrder({orderId: null, isLightOrder: true}, true)"-->
<!--						class="btnPlaner workOrder"-->
<!--				>add external work order-->
<!--				</button>-->
			</div>
		</div>
		<div class="planerChart">
			<table class="planerTable">
				<planer-header v-if="dateList" :dateList="dateList"></planer-header>
				<planer-tasks
						v-if="tasks"
						:tasks="tasks"
						:date="date"
						@updateEditWorkOrder="onPlanerWorkOrder($event, true)"
						@updatePlanerTasks="onPlanerTasks"
						@updateDayOff="onDayOff"
				></planer-tasks>
			</table>
			<line-time></line-time>
		</div>
		<preload v-if="!tasks || isPreloader"></preload>
		<planer-work-order
				v-if="isPlanerWorkOrder"
				:workOrderId="workOrderId"
				:isNewWorkOrders="isNewWorkOrders"
				:isLightWorkOrder="isLightWorkOrder"
				:permissions="permissions"
				@updateClose="onPlanerWorkOrder({ orderId: null, isLightOrder: false }, false)"
				@updateDelete="onDeletePopup($event, true)"
				@updatePreload="onPreload"
				@updateSuccess="onSuccess"
		></planer-work-order>
		<planer-day-off
				v-if="isPlanerDayOff"
				:dayOffId="dayOffId"
				@updateClose="onPlanerDayOff(false)"
				@updateDelete="onDeletePopup($event, true)"
				:permissions="permissions"
				@updateSuccess="onSuccess"
		></planer-day-off>
		<new-orders
				v-if="isNewWorkOrders"
				@updateNewOrdersClose="onNewWorkOrders(false)"
				@updateNewOrder="onNewOrder"
				@updateCommentsPopup="onCommentsPopup"
				:permissions="permissions"
		></new-orders>
		<delete-work-order
				v-if="isDeletePopup"
				:isPlanerDayOff="isPlanerDayOff"
				@updateClose="onDeletePopup(null, false)"
				@updateDelete="onDelete"
		></delete-work-order>
		<comments-popup
				v-if="isCommentsPopup"
				:commentsList="commentsList"
				:commentsData="commentsData"
				@updateCloseComments="onCloseComments"
		></comments-popup>
	</div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import PlanerHeader from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerHeader/PlanerHeader";
import LineTime from "@/components/Fleet/WorkOrdersStatistics/Planer/LineTime/LineTime";
import PlanerWorkOrder from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerWorkOrder/PlanerWorkOrder";
import DeleteWorkOrder from "@/components/Fleet/WorkOrdersStatistics/Planer/DeleteWorkOrder/DeleteWorkOrder";
import PlanerDayOff from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerDayOff/PlanerDayOff";
import PlanerTasks from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerTasks/PlanerTasks";
import NewOrders from "@/components/Fleet/WorkOrdersStatistics/Planer/NewOrders/NewOrders";
import Preload from "@/shared/Preload/Preload";
// async components
const CommentsPopup = () => import("@/components/Fleet/WorkOrders/CommentsPopup/CommentsPopup");
// helper
import getDefaultDate from "@/helper/getDefaultDate";

export default {
	name: "Planer",
	components: {
		LineTime,
		PlanerWorkOrder,
		DeleteWorkOrder,
		PlanerDayOff,
		PlanerTasks,
		PlanerHeader,
		NewOrders,
		Preload,
		CommentsPopup
	},
	computed: {
		...mapGetters([ 'dateList', 'tasks', 'newOrderCount', 'getTabPermission' ]),
		permissions() {
			return this.getTabPermission[69];
		}
	},
	data: () => ({
		date: getDefaultDate(),
		isLightWorkOrder: false,
		isPlanerWorkOrder: false,
		isPlanerDayOff: false,
		isDeletePopup: false,
		workOrderId: null,
		dayOffId: null,
		isNewWorkOrders: false,
		deleteId: null,
		count: 5,
		isPreloader: false,
		isCommentsPopup: false,
		commentsList: [],
		commentsData: null,
	}),
	methods: {
		...mapActions([
			'getPlanerTasks',
			'onClearPlanerData',
			'onRemoveWorkOrder',
			'onRemovePlanerWorkOrder',
			'onNewWorkOrder',
			'getChangePlanerTasks',
			'onWorkOrderComments',
			'onDecrementCount',
			'onRemoveDayOff'
		]),
		onPreload(value) {
			this.isPreloader = value;
		},
		async onCommentsPopup({ id, unit, unit_type }) {
			this.commentsData = { unit, unit_type };
			this.commentsList = await this.onWorkOrderComments(id);
			this.isCommentsPopup = true;
		},
		onCloseComments() {
			this.isCommentsPopup = false;
		},
		onNewOrder(id) {
			this.isPlanerWorkOrder = true;
			this.isLightWorkOrder = false;
			this.workOrderId = id;
		},
		onDeletePopup(id, value) {
			this.deleteId = id;
			this.isDeletePopup = value;
		},
		onNewWorkOrders(value) {
			this.isNewWorkOrders = value;
			this.isLightWorkOrder = false;
		},
		onPlanerWorkOrder({ orderId, isLightOrder }, value) {
			this.isPlanerWorkOrder = value;
			this.workOrderId = orderId;
			this.isLightWorkOrder = isLightOrder;
		},
		onPlanerDayOff(value) {
			this.isPlanerDayOff = value;
			this.dayOffId = null;
		},
		onSuccess() {
			this.onPlanerTasks(1);
		},
		onDate(value) {
			this.date = value;
			this.onPlanerTasks(1);
		},
		async onPlanerTasks(isResetCount) {
			this.isPreloader = true;
			if (isResetCount) {
				this.count = 5;
			} else {
				this.count = this.count + 5;
			}

			const values = {
				day: this.date,
				count: this.count
			};

			await this.getChangePlanerTasks(values);
			this.isPreloader = false;
		},
		async onDayOff(id) {
			this.dayOffId = id;
			this.isPlanerDayOff = true;
		},
		async onDelete() {
			if (this.isNewWorkOrders) {
				await this.onRemoveWorkOrder(this.deleteId);
				await this.onNewWorkOrder();
				await this.onDecrementCount();
			} else if (this.isPlanerDayOff) {
				const { status } = await this.onRemoveDayOff(this.deleteId);
				if (status) await this.onPlanerTasks(1);
			} else {
				const { status } = await this.onRemovePlanerWorkOrder(this.deleteId);
				if (status) await this.onPlanerTasks(1);
			}

			this.isDeletePopup = false;
			this.isPlanerWorkOrder = false;
			this.isPlanerDayOff = false;
		}
	},
	async mounted() {
		this.onClearPlanerData();
		await this.getPlanerTasks();
	}
};
</script>

<style lang="scss">
.planer .box {
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		display: inline-block;
		margin-left: 5px;
	}
}
</style>
<style scoped lang="scss">
	@import "planer";

</style>
